import { getColumnRange } from './getColumnRange';
import { overlap } from './overlap';
import { SurfaceItem } from '../interfaces/SurfaceItem';

/**
 * Interface to hold the result of hidden v/s visible items on Surface for a given week
 */
export interface RowItemsCollection {
    VisibleRows: SurfaceItem[][];
    HiddenItems: SurfaceItem[];
}

/**
 * This function groups items from provided collection into rows.
 * Each row contains non-overlapping all day events
 */
export default function resolveRowsWithItems(
    data: SurfaceItem[],
    columnCount: number,
    columnLength: number,
    maxRows?: number
): RowItemsCollection {
    let rows: SurfaceItem[][] = [];
    let hiddenItems: SurfaceItem[] = [];
    data.forEach(item => {
        putItemInRow(item, rows, maxRows, hiddenItems, columnCount, columnLength);
    });
    return { VisibleRows: rows, HiddenItems: hiddenItems };
}

/** Puts provided item into a row */
function putItemInRow(
    item: SurfaceItem,
    rows: SurfaceItem[][],
    maxRows: number,
    hiddenItems: SurfaceItem[],
    columnCount: number,
    columnLength: number
): void {
    for (let i = 0; i < rows.length; i++) {
        if (tryPutItemInRow(item, rows[i], columnCount, columnLength)) {
            rows[i].push(item);
            return;
        }
    }
    if (maxRows === undefined || maxRows < 0 || rows.length < maxRows) {
        rows.push([item]);
    } else {
        hiddenItems.push(item);
    }
}

/** Checks if item is not overlapping with any item already in row */
function tryPutItemInRow(
    item: SurfaceItem,
    rowItems: SurfaceItem[],
    columnCount: number,
    columnLength: number
): boolean {
    for (let j = 0; j < rowItems.length; j++) {
        let rowItem = rowItems[j];
        let slotColumn = getColumnRange(rowItem, columnCount, columnLength);
        let itemColumn = getColumnRange(item, columnCount, columnLength);
        if (overlap(itemColumn, slotColumn)) {
            return false;
        }
    }
    return true;
}
